'use client';
import React from 'react';

import Carousel from './Carousel';

const images = [
  {
    alt: 'Before and after photo of Julie using Dark Spot Formula and Future Formula',
    src: 'https://images.ctfassets.net/8pzh4g8cs30t/4aUYDiFHeJLlzHQGA4eeqa/aa0cd8a48bcf0e2672712dc7ff7eef81/before_and_after_of_julie.png',
  },
  {
    alt: 'Before and after photo of Bick using Future Formula',
    src: 'https://images.ctfassets.net/8pzh4g8cs30t/7wyxQI2o2lsCarpKUbqfmb/16954af183a72f6e4e1fa70457e6471e/before_and_after_of_bick.png',
  },
  {
    alt: 'Before and after photo of Ashley using Dark Spot Formula',
    src: 'https://images.ctfassets.net/8pzh4g8cs30t/2mIrnIM0vi3BrIZYbKqRIa/b0eaa25f1699de6bc560e1920becebd2/before_and_after_of_ashley.png',
  },
];

export const AgencyValuePropCarousel = () => {
  return <Carousel aspectRatio="3:2" images={images} />;
};
